module.exports = __webpack_public_path__ + "img/tu02.2d0fbf17.jpg";